<div
  class="header !h-[55px] !py-[14px] flex justify-between items-center !pl-[14px] !bg-[#F1F3F5] sticky !z-20 !top-0"
>
  <p class="!m-0 flex">
    Create Addendum
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 30 30"
      fill="none"
      class="ml-2"
    >
      <path
        d="M5.91842 23.5681C5.98984 23.5681 6.06127 23.5609 6.1327 23.5502L12.1398 22.4967C12.2113 22.4824 12.2791 22.4502 12.3291 22.3967L27.4684 7.25737C27.5015 7.22433 27.5278 7.18508 27.5457 7.14188C27.5636 7.09867 27.5729 7.05235 27.5729 7.00558C27.5729 6.95881 27.5636 6.91249 27.5457 6.86929C27.5278 6.82608 27.5015 6.78684 27.4684 6.7538L21.5327 0.814509C21.4648 0.746652 21.3756 0.710938 21.2791 0.710938C21.1827 0.710938 21.0934 0.746652 21.0256 0.814509L5.88627 15.9538C5.8327 16.0074 5.80056 16.0717 5.78627 16.1431L4.7327 22.1502C4.69796 22.3416 4.71037 22.5385 4.76887 22.7239C4.82737 22.9094 4.93018 23.0777 5.06842 23.2145C5.30413 23.4431 5.60056 23.5681 5.91842 23.5681ZM8.32556 17.3395L21.2791 4.38951L23.897 7.00737L10.9434 19.9574L7.76842 20.5181L8.32556 17.3395ZM28.1434 26.5681H1.8577C1.22556 26.5681 0.714844 27.0788 0.714844 27.7109V28.9967C0.714844 29.1538 0.843415 29.2824 1.00056 29.2824H29.0006C29.1577 29.2824 29.2863 29.1538 29.2863 28.9967V27.7109C29.2863 27.0788 28.7756 26.5681 28.1434 26.5681Z"
        fill="#E76B3F"
      />
    </svg>
  </p>
  <div (click)="close()">
    <mat-icon class="close-icon !mr-[10px] cursor-pointer">close</mat-icon>
  </div>
</div>
<div class="mb-4 p-5 pb-0">
  <div class="!pl-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <form [formGroup]="myForm">
          <mat-form-field class="!w-[429px]" appearance="outline">
            <mat-label>Title </mat-label>
            <input matInput formControlName="titleControl" type="text" />
          </mat-form-field>
        </form>
      </div>
    </div>
  </div>
  <app-rich-textEditor
    (contentChange)="addProjectSiteCondition($event)"
    [resetEditor]="resetRichTextEditor"
    [richTextValue]="addendumDetails"
  ></app-rich-textEditor>
  <!-- add Media -->
  <div class="mb-3">
    <button class="file-button" (click)="openRFPDesignUploadDialog()">
      Attach Documents
      <img src="assets/icons/file_upload.svg" alt="Email Icon" />
    </button>

    <div
      *ngIf="selectedFiles.length > 0"
      class="!max-h-[150px] overflow-y-auto"
    >
      <div
        *ngFor="let file of selectedFiles; let i = index"
        class="flex items-start mt-[11px]"
      >
        <div class="flex justify-start items-center">
          <div
            class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
          >
            <img
              [src]="getFileIcon(file.filePath)"
              alt="File Preview"
              class="object-cover w-auto h-[100%] cursor-pointer"
            />
          </div>
        </div>
        <div class="flex items-center">
          <span
            style="
              color: black;
              text-align: left;
              font-size: 18px;
              white-space: nowrap;
              text-overflow: ellipsis;
              display: inline-block;
              overflow: hidden;
              margin-left: 10px;
              margin-top: 5px;
            "
          >
            {{ file.name }}
          </span>
          <img
            (click)="removeSelection(i, file)"
            src="assets/icons/trash.svg"
            alt="trash"
            class="object-cover w-[13px] h-[100%] cursor-pointer ml-[8px] mt-[8px]"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="mt-5">
    <app-file-manager
      [label]="'Upload New Documents'"
      [newFileControlName]="'newAddendumFiles'"
      (newFilesUpdatedEvent)="handleNewFiles($event)"
    ></app-file-manager>
  </div>
  <div
    class="!mb-[60px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
        (click)="submitRFPAddendum()"
      >
        Submit
      </button>
    </div>
  </div>
</div>
